(function () {
    'use strict';
    var controllerId = 'cndPAziendaAdd';
    angular.module('app').controller(controllerId, ['$scope', 'common', 'datacontext', '$uibModalInstance', 'bootstrap.dialog', 'partAzienda', 'paesi', 'province', 'tIndirizzi', 'tFormaGiuridica', 'partecipazioneId', 'capofilaId', 'isCapofila', 'tRuoloCode', 'isSuper', fn_cndPAziendaAdd]);

    function fn_cndPAziendaAdd($scope, common, datacontext, $uibModalInstance, bDialog, partAzienda, paesi, province, tIndirizzi, tFormaGiuridica, partecipazioneId, capofilaId, isCapofila, tRuoloCode, isSuper) {
        $scope.paesi = paesi;
        $scope.province = province;        
        $scope.tIndirizzi = tIndirizzi;
        $scope.tFormaGiuridica = tFormaGiuridica;  
        $scope.isCapofila = isCapofila;
        //console.info('isCapofila %s', isCapofila);
        $scope.isSuper = isSuper;
        $scope.capofilaId = capofilaId;
        $scope.comuni_nasc = [];
        $scope.comuni_sedeLeg = [];

        if (partAzienda) {
            $scope.title = 'Modifica Partner';
            $scope.record = jQuery.extend({}, partAzienda); //Clona oggetto
            
            //console.info('cndPAziendaAdd', $scope.record);
            //item = objToDto($scope.record);
            $scope.action = 'Edit';

            if ($scope.record.L_DtNasc != null) {
                $scope.record.L_DtNasc = new Date($scope.record.L_DtNasc);
            }
            if ($scope.record.SGO_DDG_Dt != null) {
                $scope.record.SGO_DDG_Dt = new Date($scope.record.SGO_DDG_Dt);
            }
            if ($scope.record.RUNTS_Dt != null) {
                $scope.record.RUNTS_Dt = new Date($scope.record.RUNTS_Dt);
            }

            getAteco($scope.record.TAtecoId);
            getComuni_Nasc($scope.record.L_NascProvinciaId);
            getComuni_SedeLeg($scope.record.SedeLegale_ProvinciaId);
        }
        else {
            $scope.title = 'Nuovo Partner';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.PartecipazioneId = partecipazioneId;
            //$scope.record.Parent = { Id: 0 };


            $scope.pAzienda = $scope.record.Parent;

            

            $scope.record.bAccreditato = false;
            $scope.record.ATS = true;
            if (tRuoloCode == 'AZD_PROM-FAM1')
                $scope.record.TRuoloCode = 'AZD_PRTN-FAM1';
                //$scope.record.TRuolo = { Code: 'AZD_PRTN-FAM1'};
            if (capofilaId) {
                $scope.record.ParentId = $scope.capofilaId;
            }            
            $scope.record.L_NascPaeseId = 0;
            $scope.record.SedeLegale_PaeseId = 0;
            $scope.record.SedeLegale_TIndirizzoId = 1;

            //$scope.record.RagioneSociale = 'Partner';
            //$scope.record.L_Cognome = 'Blancato';
            //$scope.record.L_Nome = 'Antonino';
            //$scope.record.L_CodiceFiscale = 'BLNNNN82P20I754N';
            //$scope.record.L_Sesso = 'M';
            //$scope.record.L_DtNasc = '20/09/1982';
            //$scope.record.L_NascProvinciaId = 89;
            //$scope.record.L_NascComuneId = 6886;
            //$scope.record.SedeLegale_ProvinciaId = 89;
            //$scope.record.SedeLegale_ComuneId = 6886;


            $scope.action = 'Add';
            $scope.record.RUNTS_Type = 0;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        
        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.open = function ($event, iOpened) {
            //console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            $scope.opened2 = false;
            $scope.opened3 = false;
            if (iOpened == 1) {
                $scope.opened1 = true;
            }
            else if (iOpened == 2) {
                $scope.opened2 = true;
            }
            else if (iOpened == 3) {
                $scope.opened3 = true;
            }
                
        };

        $scope.clear = function ($event, iOpened) {
            //console.log('clear');
            if (iOpened == 1) {
                $scope.record.L_DtNasc = '';
                $scope.changed = true;
            }
            else if (iOpened == 2) {
                $scope.record.SGO_DDG_Dt = '';
                $scope.changed = true;
            }
            else if (iOpened == 3) {
                $scope.record.RUNTS_Dt = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.PartecipazioneId = partecipazioneId;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        //function objToDto(rec) {
        //    console.info('objToDto', rec);
        //    rec.Parent.TRuoloCode = rec.Parent.TRuolo.Code;
        //    rec.Parent.L_NascPaeseId = rec.Parent.L_NascPaese.Id;
        //    rec.Parent.L_NascProvinciaId = rec.Parent.L_NascProvincia.Id;
        //    rec.Parent.L_NascComuneId = rec.Parent.L_NascComune.Id;
        //    rec.Parent.SedeLegale_PaeseId = rec.Parent.SedeLegale_Paese.Id;
        //    rec.Parent.SedeLegale_ProvinciaId = rec.Parent.SedeLegale_Provincia.Id;
        //    rec.Parent.SedeLegale_ComuneId = rec.Parent.SedeLegale_Comune.Id;
        //    rec.Parent.SedeLegale_TIndirizzoId = rec.Parent.SedeLegale_TIndirizzo.Id;
   
        //    return rec;
        //}

        //function dtoToObj(rec) {
        //    console.info('dtoToObj', rec);
        //    rec.Parent.TRuolo = { Code: rec.Parent.TRuoloCode };
        //    rec.Parent.L_NascPaese = { Id: rec.Parent.L_NascPaeseId };
        //    rec.Parent.L_NascProvincia = { Id: rec.Parent.L_NascProvinciaId };
        //    rec.Parent.L_NascComune = { Id: rec.Parent.L_NascComuneId };
        //    rec.Parent.SedeLegale_Paese = { Id: rec.Parent.SedeLegale_PaeseId };
        //    rec.Parent.SedeLegale_Provincia = { Id: rec.Parent.SedeLegale_ProvinciaId };
        //    rec.Parent.SedeLegale_Comune = { Id: rec.Parent.SedeLegale_ComuneId };
        //    rec.Parent.SedeLegale_TIndirizzo = { Id: rec.Parent.SedeLegale_TIndirizzoId };

        //    return rec;
        //}

        /*
        function addItem(item) {
            var pAzienda = { Id: 0, PartecipazioneId: partecipazioneId, Parent: item };
            //console.info('addItem',pAzienda);
            //item = dtoToObj(item);
            console.info('addItem', pAzienda);
            return datacontext.pAzienda_addExt(pAzienda).then(function (data) {
                return data;
            });
        }
        */

        function addItem(item) {
            return datacontext.azienda_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            //var pAzienda = { Id: 0, PartecipazioneId: partecipazioneId, Parent: item };
            //console.info('updateItem', pAzienda);
            //item = dtoToObj(item);
            //console.info('addItem', item);
            return datacontext.azienda_merge(item).then(function (data) {
                return data;
            });
        }

        function getAteco(id) {
            if (!id) return;
            return datacontext.tAteco_get(id).then(function (data) {
                if (data != null)
                    $scope.record.searchTextAteco = data.Title;
            });
        }

        $scope.change_RUNTS = function () {
            $scope.record.RUNTS_Num = '';
            $scope.record.RUNTS_Dt = '';
        }

        // #region FUNZIONI LOCALIZZAZIONE

        $scope.change_Paesi_Nasc = function () {
            if ($scope.record.L_NascPaeseId > 0) {
                $scope.record.L_NascComuneId = 0;
                $scope.record.L_NascProvinciaId = 0;
            }
        };

        $scope.change_Comuni_Nasc = function (idprov) {
            $scope.record.L_NascComuneId = '';
            getComuni_Nasc(idprov);
        };

        function getComuni_Nasc(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.L_NascProvinciaId != idprov)
                $scope.comuni_nasc = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni_nasc = data;
            });
        }

        $scope.change_Paesi_SedeLeg = function () {
            if ($scope.record.SedeLegale_PaeseId > 0) {
                $scope.record.SedeLegale_ComuneId = 0;
                $scope.record.SedeLegale_ProvinciaId = 0;
            }
        };

        $scope.change_Comuni_SedeLeg = function (idprov) {
            $scope.record.SedeLegale_ComuneId = '';
            getComuni_SedeLeg(idprov);
        };

        function getComuni_SedeLeg(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.SedeLegale_ProvinciaId != idprov)
                $scope.comuni_sedeLeg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni_sedeLeg = data;
            });
        }

        // #endregion

        // #region FUNZIONI DI SUPPORTO

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- SUGGESTION PER CODICE ATECO -#-#-#-#-#-#
        //Define Suggestions List
        $scope.suggestionsAteco = [];
        $scope.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        $scope.selectedIndexAteco = -1;
        //Function To Call On ng-change
        $scope.searchAteco = function () {
            $scope.suggestionsAteco = [];
            $scope.suggestionsObjAteco = [];
            if ($scope.record.searchTextAteco == undefined) return;
            if ($scope.record.searchTextAteco.length < 5) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText($scope.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    $scope.suggestionsAteco = [];
                    $scope.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        $scope.suggestionsAteco.push(item.Name);
                    });
                }
                if ($scope.suggestionsAteco.length == 1) {
                    $scope.AssignValueAndHideAteco(0);
                }
            });
        };
        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof (val) != 'undefined') {
                $scope.record.searchTextAteco = $scope.suggestionsAteco[$scope.selectedIndexAteco];
                $scope.record.TAtecoId = $scope.suggestionsObjAteco[$scope.selectedIndexAteco].Id;
            }
        });
        //Reset Text of Ateco
        $scope.resetTextAteco = function () {
            if ($scope.record.TAtecoId > 0) {
                $scope.record.TAtecoId = '';
                $scope.validAteco = false;
                $scope.record.searchTextAteco = '';
            }
        };
        //Text Field Events
        //Function To Call on ng-keydown
        $scope.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if ($scope.selectedIndexAteco + 1 !== $scope.suggestionsAteco.length) {
                    $scope.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if ($scope.selectedIndexAteco - 1 !== -1) {
                    $scope.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                $scope.suggestionsAteco = [];
                $scope.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        $scope.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if ($scope.record.searchTextAteco == "") {
                    $scope.suggestionsAteco = [];
                    $scope.suggestionsObjAteco = [];
                }
            } else {
                if ($scope.record.TAtecoId > 0) {
                    $scope.record.TAtecoId = '';
                    $scope.record.searchTextAteco = '';
                }
            }
        };
        //======================================
        //List Item Events
        //Function To Call on ng-click
        $scope.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            $scope.record.searchTextAteco = $scope.suggestionsAteco[index];
            $scope.record.TAtecoId = $scope.suggestionsObjAteco[index].Id;
            $scope.suggestionsAteco = [];
            $scope.suggestionsObjAteco = [];
        };
        //======================================
        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- END -#-#-#-#-#-#

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR CF -#-#-#-#-#-#
        $scope.existsCF = false;
        $scope.searchCF = function (value) {
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri            
            $scope.existsCF = true;

            return datacontext.pAzienda_exists(0, 0, 0, value, '').then(function (data) {
                $scope.existsCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR PIVA -#-#-#-#-#-#
        $scope.existsPIVA = false;
        $scope.searchPIVA = function (value) {
            $scope.existsPIVA = false;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri 
            $scope.existsPIVA = true;

            return datacontext.pAzienda_exists(0, 0, 0, '', value).then(function (data) {
                $scope.existsPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        $scope.validPIVA = true;
        $scope.checkPIVA = function (value) {
            $scope.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            $scope.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return $scope.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        $scope.validCF = true;
        $scope.checkCF = function (value) {
            $scope.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            if (value.length == 11) isEnte = true;
            $scope.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return $scope.validCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        $scope.validFieldsCF = true;
        $scope.checkFieldsCF = function () {
            $scope.validFieldsCF = true;
            if ($scope.record.L_CodiceFiscale == undefined) return;
            if ($scope.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if ($scope.record.L_Nome == undefined) return;
            if ($scope.record.L_Cognome == undefined) return;
            if ($scope.record.L_Sesso == undefined) return;
            if ($scope.record.L_NascPaeseId == 0 && ($scope.record.L_NascComuneId == undefined || $scope.record.L_NascComuneId == 0)) return;
            if ($scope.record.L_DtNasc == undefined || $scope.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString($scope.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy
            $scope.validFieldsCF = false;
            return datacontext.validazione_fieldsCF($scope.record.L_CodiceFiscale, $scope.record.L_Nome, $scope.record.L_Cognome, $scope.record.L_Sesso, strDtNasc, $scope.record.L_NascPaeseId, $scope.record.L_NascComuneId).then(function (data) {
                return $scope.validFieldsCF = data;
            });
        };

        $scope.changeAccred = function () {
            if (!$scope.record.bAccreditato) {
                $scope.record.SGO_DDG_Num = '';
                $scope.record.SGO_DDG_Dt = '';
            }
        };

        $scope.changeCapofila = function () {
            if (!$scope.record.Capofila) {
                var msg = 'Attenzione, deve essere presente almeno un ente come Capofila / mandatario';
                bDialog.informationDialog(msg);
            }
        };

        // #endregion

    }
})();